import { IComponentOptions } from "angular";
import { DefinitionsDetailMachineViewController } from "./controller";

export const vsComponentName = "progressiveDefinitionMachineViewComponent";

export const progressiveDefinitionMachineViewComponentOptions: IComponentOptions =
  {
    controller: DefinitionsDetailMachineViewController,
    controllerAs: "stateController",
    template: require("!html-loader!./index.html").default,
    bindings: {
      progressiveDefinition: "<",
      date: "<",
    },
  };
